import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import DialogPlugin from "./plugins/dialog";
import ElementUI from 'element-ui';
// import NProgress from "nprogress"
// import "nprogress/nprogress.css"
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import '@/views/index/styles/chart-popup.scss';

Vue.directive('append-to-body', {
	inserted(el) {
		document.body.appendChild(el);
	},
	unbind(el) {
		try {
			if (el && el.parentNode === document.body) {
				document.body.removeChild(el);
			}
		} catch (e) {
			/* 节点可能已被移除 */
		}
	},
});

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue(); // 全局事件总线
Vue.use(DialogPlugin);
Vue.use(ElementUI);
Vue.use(dataV)


// NProgress.inc(0.2)
// NProgress.configure({
//   easing: "ease",
//   speed: 500,
//   showSpinner: false
// })


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
